import {
  NavigationGuardNext,
  RouteLocationNormalized,
  RouteLocationRaw,
} from 'vue-router';
import { NAMES_FOR_REDIRECT_FROM_USER_TO_MYPAGE } from '@/routers-capability/constants';
import { counterpartRouteName } from '@/routers-capability/designRoutes';
import { shouldUseNextLayout } from '@/utils/composables/useLayoutPreference';
import { userSession } from '@/utils/userSession';

export function shouldRedirectToLogin(to: RouteLocationNormalized) {
  // https://router.vuejs.org/ja/guide/advanced/meta.htmlを参考に実装
  if (
    !to.matched.some(
      record =>
        record.meta.type === 'account' ||
        record.meta.type === 'mobile_app_download' ||
        record.meta.type === 'no_login_required_redirect' ||
        record.meta.accessScope === 'public',
    )
  ) {
    if (!userSession.isActive()) {
      return true;
    }
  }
  return false;
}

export function shouldRedirectToMypage(to: RouteLocationNormalized) {
  if (
    to.matched.some(record => record.meta.type === 'user') &&
    to.params.userId
  ) {
    return userSession.getUserId() === Number(to.params.userId);
  }
  return false;
}

export function redirectToCurrentDesign(
  to: RouteLocationNormalized,
): RouteLocationRaw | undefined {
  const target = shouldUseNextLayout() ? 'next' : 'legacy';

  const counterpart = counterpartRouteName(to.name, target);
  if (counterpart) {
    return { name: counterpart, params: to.params, query: to.query };
  }

  // 対向のルートがない画面（メディアの表示設定など）はトップにする
  if (to.meta.availableIn && to.meta.availableIn !== target) {
    return { path: '/' };
  }

  return undefined;
}

export function redirectToMypage(
  to: RouteLocationNormalized,
  next: NavigationGuardNext,
) {
  const name =
    NAMES_FOR_REDIRECT_FROM_USER_TO_MYPAGE[
      to.name as keyof typeof NAMES_FOR_REDIRECT_FROM_USER_TO_MYPAGE
    ];
  if (name) {
    next({ name });
  }
}
